import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiLink } from '@app/packages/api/v2/types/entities'
import { createLoadable, mapThunkSelector } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserResultSelector } from '@app/store/selectors/profile'

import { routingDateSelector } from './routing'

export const linksSlice = createReduxSlice<SliceState<ApiLink[]>>('links')

export const linksResultSelector = createSelector([linksSlice.selector, routingDateSelector, profileUserResultSelector], (slice, date, userResult) =>
  createLoadable(c => {
    const user = c.unwrap(userResult)
    if (!user) throw new Error('Profile user is missing')
    return withCheckedSliceState(c, {
      sliceState: slice,
      slice: linksSlice,
      hash: user.id,
      date: { date, expiresInMinutes: 30 },
      load: async dispatch => {
        const { getLinks } = await import('@app/packages/api/v2/actions/links')
        const resp = await dispatch(callV2Api(getLinks())).catch(catchFetchDataError(dispatch, 'Links fetch failed'))
        return resp.data
      },
    })
  })
)

export const telegramLinkResultSelector = mapThunkSelector(linksResultSelector, links => links.find(l => l.id === 'invitation_to_tg_chat_for_sitters') ?? null)
